import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import overlayFactory from "react-bootstrap-table2-overlay";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { WithAuth } from "../../components/Authorization/WithAuth";
import Card from "../../components/Cards/Card";
import { Next } from "../../components/Icons/Icons";
import { Tooltip } from "../../components/Utils/Tooltips";
import { MembersFilters } from "../../components/Team/MembersFilters";
import { usePractitionersStartup } from "../Users/Hooks";
import { getPractitionersFilters } from "../../api/clinicalTrial";
import { HandleApiError } from "../../components/Notifications/APIErrorHandler";

export const TeamMembers = (props) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState({
    pagination: {
      page: 1,
      sizePerPage: 10,
    },
    onlyDoctor: true,
  });
  const [indicationOptions, setIndicationOptions] = useState();
  const [protocolIndicationOptions, setProtocolIndicationOptions] = useState();

  const [users, isLoading, totalSize, handleFilterChange, setQueryInternal] =
    usePractitionersStartup(query);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getPractitionersFilters();

        if (result.status === 200) {
          setIndicationOptions(result.data.specialties);
          setProtocolIndicationOptions(result.data.protocolsSpecialties);
        }
      } catch (error) {
        HandleApiError(error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTableChange = (type, { page, sizePerPage }) => {
    setQuery((prev) => {
      const newQuery = {
        ...prev,
        pagination: {
          ...prev.pagination,
          page,
          sizePerPage,
        },
      };
      setQueryInternal(newQuery);
      return newQuery;
    });
  };

  const columns = [
    {
      dataField: "fullName",
      text: t("team.header.name"),
      headerStyle: { width: "200px" },
    },
    {
      dataField: "speciality.description",
      text: t("team.header.associatedSpecialty"),
      headerStyle: { width: "200px" },
    },
    {
      dataField: "startupsCount",
      text: t("team.header.clinicalTrials"),
      headerStyle: { width: "200px" },
      formatter: function (_cell, row, rowIndex) {
        return (
          <span
            style={{
              padding: "6px 12px",
              borderRadius: "20px",
              fontWeight: "bold",
              fontSize: "14px",
              display: "inline-flex",
              alignItems: "center",
              backgroundColor: "#D3D3D3",
            }}
          >
            {row.startupsCount}
            <span
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#808080",
                borderRadius: "50%",
                marginLeft: "8px",
              }}
            />
          </span>
        );
      },
    },
    {
      dataField: "view",
      text: t("team.header.viewMore"),
      isDummyField: true,
      headerClasses: "header-protocol-actions",
      classes: "row-protocol-actions",
      headerStyle: { width: "100px" },
      headerAlign: "center",
      align: "center",
      formatter: function (_cell, row, rowIndex) {
        return (
          <div key={rowIndex}>
            <Tooltip
              tooltip={t("protocols.visitTracking.viewProtocol")}
              id={"tooltipconfig-" + row.id}
            >
              <WithAuth requiredPermission={["Protocols.Edit"]}>
                <NavLink
                  to={`/admin/clinicalTrials/team/edit/${row.id}`}
                  className="btn-table-actions"
                >
                  <Next />
                </NavLink>
              </WithAuth>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return (
    <Card
      header={
        <div className="row">
          <MembersFilters
            isLoading={!indicationOptions || !protocolIndicationOptions}
            specialtiesOptions={indicationOptions}
            protocolSpecialtiesOptions={protocolIndicationOptions}
            onChangeFilter={handleFilterChange}
          />
        </div>
      }
      content={
        <BootstrapTable
          bordered={false}
          hover
          keyField="id"
          data={users}
          columns={columns}
          classes="table-spaced table-spaced-small"
          wrapperClasses="table-responsive"
          pagination={paginationFactory({
            page: query.pagination.page,
            sizePerPage: query.pagination.sizePerPage,
            totalSize: totalSize,
            hideSizePerPage: true,
          })}
          onTableChange={handleTableChange}
          noDataIndication={() => <>{t("commons.noData")}</>}
          loading={isLoading}
          overlay={overlayFactory({ spinner: true })}
        />
      }
    />
  );
};
